import React, { useState } from "react";
import { supabase } from "../supabaseClient";
import { useAuth } from "../contexts/AuthContext";

const NewCircuitModal = ({ isOpen, onClose, onSuccess }) => {
  const { user, tenant } = useAuth();
  const [name, setName] = useState("");
  const [framework, setFramework] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!name.trim()) newErrors.name = "Name is required";
    if (!framework) newErrors.framework = "Framework is required";
    
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
        setIsLoading(true);
        const { data, error } = await supabase
            .from("circuits")
            .insert([
            {
                name: name,
                framework_id: framework,
                user_id: user.id,
                tenant_id: tenant
            },
            ])
            .select();

        if (error) throw error;
        onSuccess(data[0]);
        setErrors({});
        onClose();

    } catch (err) {
      setErrors({ response: err.message });
    }
    finally{
        setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal is-active">
      <div className="modal-background" onClick={onClose}></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">Create New Circuit</p>
          <button className="delete" onClick={onClose}></button>
        </header>
        <section className="modal-card-body">
          {errors.response && (
            <div className="notification is-danger">
              <button className="delete" onClick={() => setErrors({})}></button>
              {errors.response}
            </div>
          )}
          <div className="field">
            <label className="label">Name</label>
            <div className="control">
              <input
                className={`input ${errors.name ? "is-danger" : ""}`}
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter circuit name"
              />
              {errors.name && <p className="help is-danger">{errors.name}</p>}
            </div>
          </div>
          <div className="field">
            <label className="label">Framework</label>
            <div className="control">
              <div className="select is-fullwidth">
                <select
                  className={errors.framework ? "is-danger" : ""}
                  value={framework}
                  onChange={(e) => setFramework(e.target.value)}
                >
                  <option value="">Select a framework</option>
                  <option value="263c1892-4e62-4404-96db-7ab2fb8acef5">gnark v0.14.0</option>
                  <option value="3615bafa-fa60-4fdd-957d-68d0daa275f1">gnark v0.13.0</option>
                  <option value="b3a3c6d1-632e-4cf2-a65d-b152c5c47578">Circom</option>
                  <option value="c880e88f-1990-4d3f-856b-f8993f8d94a4">Noir</option>
                </select>
              </div>
              {errors.framework && <p className="help is-danger">{errors.framework}</p>}
            </div>
          </div>
        </section>
        <footer className="modal-card-foot">
          <div className="buttons">
            <button className="button is-danger" onClick={onClose}>
              Cancel
            </button>
            <button className={`button is-link ${isLoading ? "is-loading" : ""}`} onClick={handleSubmit}>
              Create
            </button>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default NewCircuitModal;